// extracted by mini-css-extract-plugin
module.exports = {"qrcode-container":"style_qrcode-container__2h2UO"};